import React from 'react';
import Spacing from '../Spacing';
import SectionHeadingStyle3 from '../SectionHeading/SectionHeadingStyle3';
import { Icon } from '@iconify/react';
import AuthorWidget from '../Widget/AuthorWidget';
import { pageTitle } from '../../helpers/PageTitle';

export default function Blog3() {
  pageTitle('Commercial Solar Success Stories: ROI in Action');
  
  const handleSubmit = (e) => {
    e.preventDefault();
    const formData = new FormData(e.target);
    const data = {
      name: formData.get('name'),
      email: formData.get('email'),
      comment: formData.get('comment')
    };
    console.log('Sending to company email:', data);
  };

  return (
    <>
      <Spacing lg="70" md="70" />
      <Spacing lg="140" md="80" />
      <SectionHeadingStyle3
        title="Commercial Solar Success Stories: ROI in Action"
        variant="text-center"
        shape="shape_5"
        category="Commercial Solar"
        date="20 Aug 2024"
        avatar="Business Success"
        avatarLink="/"
      />
      <Spacing lg="75" md="60" />
      <div className="container">
        <img
          src="/images/blog/post_details_1.jpeg"
          alt="Commercial Solar Success"
          className="cs_radius_15"
        />
        <div className="cs_height_60 cs_height_lg_40" />
        <div className="cs_post_details">
          <h3>
            How Local Businesses Are Thriving with Solar Power
          </h3>
          <p>
            Discover how three local businesses reduced their operational costs by 60% through strategic solar installations. These real-world examples demonstrate the transformative power of commercial solar solutions.
          </p>
          <p>
            From manufacturing facilities to office complexes, businesses across sectors are leveraging solar power to gain competitive advantages and improve their bottom line.
          </p>
          <div className="cs_height_10 cs_height_lg_5" />
          <div className="row">
            <div className="col-md-4">
              <img
                src="/images/blog/post_details_2.jpeg"
                alt="Manufacturing Solar"
                className="w-100"
              />
            </div>
            <div className="col-md-4">
              <img
                src="/images/blog/post_details_3.jpeg"
                alt="Office Solar"
                className="w-100"
              />
            </div>
            <div className="col-md-4">
              <img
                src="/images/blog/post_details_4.jpeg"
                alt="Retail Solar"
                className="w-100"
              />
            </div>
          </div>
          <div className="cs_height_10 cs_height_lg_5" />
          <h3>Case Study: Manufacturing Excellence</h3>
          <p>
            Local manufacturer ABC Industries cut their energy costs by 70% in the first year after installing our commercial solar solution. Their success story showcases the potential for massive savings in energy-intensive industries.
          </p>
          <blockquote>
            "The ROI exceeded our expectations. Our solar installation paid for itself in just 3.5 years, and we're now saving over $12,000 monthly on energy costs."
            <small>Michael Roberts, CEO of ABC Industries</small>
          </blockquote>
          <p>
            Soketry Solutions offers tailored commercial solar packages that consider your business's unique energy needs, space constraints, and financial goals.
          </p>
          <ul>
            <li>Average ROI period: 3-5 years</li>
            <li>Energy cost reduction: 50-70%</li>
            <li>Enhanced brand value through sustainability</li>
            <li>Tax incentives and depreciation benefits</li>
            <li>Increased property value</li>
          </ul>
        </div>
        <div className="cs_height_30 cs_height_lg_10" />
        <div className="cs_post_share">
          <div className="cs_categories">
            <a href="/" className="cs_category">
              Commercial Solar
            </a>
            <a href="/" className="cs_category">
              Business Success
            </a>
          </div>
          <div className="text-center">
            <div className="cs_post_share_btns">
              <a href="/">
                <Icon icon="fa6-brands:twitter" />
              </a>
              <a href="/">
                <Icon icon="fa6-brands:facebook-f" />
              </a>
              <a href="/">
                <Icon icon="fa6-brands:linkedin-in" />
              </a>
            </div>
            <span className="cs_post_share_title">Share this Article</span>
          </div>
        </div>
        <div className="cs_height_50 cs_height_lg_40" />
        <AuthorWidget />
        <div className="cs_height_88 cs_height_lg 60" />
        <h2 className="text-center cs_fs_50 mb-0">Leave A Comment</h2>
        <div className="cs_height_60 cs_height_lg 30" />
        <form onSubmit={handleSubmit} className="row">
          <div className="col-lg-6">
            <input
              type="text"
              name="name"
              className="cs_form_field_2"
              placeholder="Your Name"
              required
            />
            <div className="cs_height_50 cs_height_lg 30" />
          </div>
          <div className="col-lg-6">
            <input
              type="email"
              name="email"
              className="cs_form_field_2"
              placeholder="Your Email"
              required
            />
            <div className="cs_height 50 cs_height_lg 30" />
          </div>
          <div className="col-lg-12">
            <textarea
              name="comment"
              cols={30}
              rows={7}
              className="cs_form_field_2"
              placeholder="Share your thoughts on commercial solar solutions"
              required
            />
            <div className="cs_height 60 cs_height_lg 30" />
          </div>
          <div className="col-lg-12 text-center">
            <button type="submit" className="cs_btn cs_style_1">
              Submit Comment{' '}
              <span>
                <i className="fa-solid fa-arrow-right" />
              </span>
            </button>
          </div>
        </form>
        <div className="cs_height_150 cs_height_lg 80" />
      </div>
    </>
  );
} 